import React, { Component } from 'react';
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import moment from "moment";
import * as Highcharts from 'highcharts';
import CSSModules from "react-css-modules";
import { Button, Drawer, Select, MenuItem, Modal, TextField } from "@material-ui/core";
import { Close, DateRange, Delete, Lens } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";

import comment_add_icon from "../../assets/Icons/comment_add.png";
import comment_list_icon from "../../assets/Icons/comment_list.png";

import styles from "./styles.scss";

// adds Comment buttons to a chart
@CSSModules(styles, { allowMultiple: true })
class ChartCommentModals extends Component {
    state = {
        hidden: false,
        addCommentOpen: false,
        listCommentsOpen: false,
        addCommentViaChartOpen: false,
        addCommentViaGenericOpen: false,
        errors: [],
    }

    componentDidMount() {
        this._addCommentViaChartClick = this._addCommentViaChartClick.bind(this);
        this._addCommentViaGenericClick = this._addCommentViaGenericClick.bind(this);
        this._saveChartComment = this._saveChartComment.bind(this);
        this._saveGenericComment = this._saveGenericComment.bind(this);
    }

    _formatDate(ms) {
        var t = (new Date(ms)).toUTCString();
        return t.substring(0, t.length - 4);
    }

    render() {
        return (
            <div id="hmmm1">
                <Modal
                    open={this.props.addCommentOpen}
                    style={{ display: "flex", justifyContent: "center" }}
                    onClose={() => {
                        this.props.addCommentClose();
                    }}>
                    <div className="modal-wrap">
                        <div style={{marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
                            <div style={{flex: 1}} />
                            <Close onClick={() => this.props.addCommentClose()}/>
                        </div>
                        <div styleName="modal-title center">
                            Add New Comment
                        </div>
                        <div style={{textAlign:'center',paddingTop:20,color:'#4D4D4D'}}>
                            Please select the type of comment to add
                        </div>
                        <div style={{width:380, height: 70,display:'flex', flexDirection:'row', paddingTop:10}}>
                            <Button
                                styleName="search-button search-button-large"
                                onClick={this._addCommentViaChartClick}
                                style={{ flex: '1 1 0', margin: "0px 10px", fontWeight:600,backgroundColor:'#EFEFEF' }}
                                >
                                Place comment on chart
                            </Button>
                            <Button
                                styleName="search-button search-button-large"
                                onClick={this._addCommentViaGenericClick}
                                style={{ flex: '1 1 0', margin: "0px 10px", fontWeight:600,backgroundColor:'#EFEFEF' }}
                                >
                                Generic Comment
                            </Button>
                        </div>
                    </div>
                </Modal>
                <Modal
                    open={this.props.listCommentsOpen}
                    style={{ display: "flex", justifyContent: "center" }}
                    onClose={() => {
                        this.props.listCommentsClose();
                    }}>
                    <div className="modal-wrap">
                        <div style={{marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
                            <div style={{flex: 1}} />
                            <Close onClick={() => this.props.listCommentsClose()}/>
                        </div>
                        <div styleName="modal-title" style={{fontSize:16,fontWeight:500,color:'#4D4D4D'}}>
                            Comments
                        </div>
                        <div style={{height:10}}></div>
                        <div style={{}}>
                            {
                                this.props.commentList !== undefined && this.props.commentList.length > 0 &&
                                this.props.commentList.map((comment, index) => {
                                    return (
                                        <div key={index} styleName="trash-can-parent" style={{display:'flex',flexDirection:'row',paddingBottom:20}}>
                                            <div style={{width:380}}>
                                                <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                                    {
                                                        (comment.toDate === undefined || comment.toDate == null) &&
                                                        <Lens style={{width:8,paddingRight:12,color:"#526BAF"}} />
                                                    }
                                                    <div style={{fontSize:14,fontWeight:600,paddingRight:12,color:'#4D4D4D'}}>{comment.username}</div>
                                                    <div style={{fontSize:14,fontWeight:400,color:'#999'}}>{moment(comment.createdOnUtc).format("ddd, DD MMM YY, h:mma")}</div>
                                                </div>
                                                <div style={{maxWidth: 300, paddingTop:7,color:'#4D4D4D'}}>{comment.description}</div>
                                            </div>
                                            <Delete style={{cursor:'pointer'}} styleName="trash-can" onClick={() => this.props.setDeletingComment(comment)}/>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </Modal>
                <Modal open={this.props.chartCommentOpen}
                    styleName="chart-modal-container"
                    onClose={() => {
                        this.props.addCommentViaChartClose();
                        //this.clearModalData();
                    }}>
                    <div className="modal-wrap">
                        <div style={{marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
                            <div style={{flex: 1}} />
                            <CloseIcon onClick={() => {this.props.addCommentViaChartClose(); /*this.clearModalData();*/ }}/>
                        </div>
                        <div styleName="chart-modal-content" style={{display: "flex", flexDirection: "column"}}>
                            <div>
                                <div styleName="modal-title">Chart Comment</div>
                                <div style={{textAlign: 'center'}}>{this._formatDate(this.props.xVal)}</div>
                            </div>
                            
                            <div style={{width:380}}>
                                <TextField type="text" value={this.state.description} style={{width:'100%', marginBottom:10}} onChange={(evt) => {this.setState({description: evt.target.value});}} label="Text" multiline={true} styleName="ic-description" />
                                
                                <div style={{display:'flex'}}>
                                    <div style={{flex: '1 1 0'}}></div>
                                    <div style={{flex: '1 1 0'}}></div>
                                    <Button onClick={() => this._saveChartComment()} styleName="ic-save-button" style={{backgroundColor:'#EFEFEF'}}>
                                        Save
                                    </Button>
                                </div>
                                <div>
                                    {
                                        this.state.errors.map((error, index) => {
                                            return (<div styleName="pst-error" key={index}>{error}</div>)
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal open={this.props.genericCommentOpen}
                    styleName="chart-modal-container"
                    onClose={() => {
                        this.props.addCommentViaGenericClose();
                        //this.clearModalData();
                    }}>
                    <div className="modal-wrap">
                        <div style={{marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
                            <div style={{flex: 1}} />
                            <CloseIcon onClick={() => {this.props.addCommentViaGenericClose(); /*this.clearModalData();*/ }}/>
                        </div>
                        <div styleName="chart-modal-content" style={{display: "flex", flexDirection: "column"}}>
                            <div>
                                <div styleName="modal-title">{this.state.editDto ? "Edit " : "New "}Comment</div>
                            </div>
                            
                            <div style={{width:380}}>
                                <TextField type="text" value={this.state.description} style={{width:'100%', marginBottom:10}} onChange={(evt) => {this.setState({description: evt.target.value});}} label="Text" multiline={true} styleName="ic-description" />
                                
                                <div style={{display:'flex'}}>
                                    <div style={{flex: '1 1 0'}}></div>
                                    <div style={{flex: '1 1 0'}}></div>
                                    <Button onClick={() => this._saveGenericComment()} styleName="ic-save-button" style={{backgroundColor:'#EFEFEF'}}>
                                        Save
                                    </Button>
                                </div>
                                <div>
                                    {
                                        this.props.errors.map((error, index) => {
                                            return (<div styleName="pst-error" key={index}>{error}</div>)
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal open={this.props.deleteConfirmOpen}
                    styleName="chart-modal-container"
                    onClose={() => {
                        this.props.deleteConfirmClose();
                        //this.clearModalData();
                    }}>
                    <div className="modal-wrap">
                        <div style={{marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
                            <div style={{flex: 1}} />
                            <CloseIcon onClick={() => {this.props.deleteConfirmClose(); /*this.clearModalData();*/ }}/>
                        </div>
                        <div styleName="chart-modal-content" style={{display: "flex", flexDirection: "column"}}>
                            <div>
                                <div styleName="modal-title">Delete Comment?</div>
                            </div>
                            
                            <div style={{width:380,display:'flex',flexDirection:'row', paddingTop:10}}>
                                <Button onClick={() => this.props.deleteComment(this.props.selectedRuleInstance.ruleInstanceId, this.props.time.startDate, this.props.time.endDate)} styleName="ic-save-button" style={{backgroundColor:'#EFEFEF',margin:4}}>
                                    Yes
                                </Button>
                                <Button onClick={() => this.props.deleteConfirmClose()} styleName="ic-save-button" style={{backgroundColor:'#EFEFEF',margin:4}}>
                                    No
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    _saveChartComment() {
        this.props.saveChartComment(this.props.selectedRuleInstance.ruleInstanceId, this.state.description, this.props.time.startDate, this.props.time.endDate);
    }
    _saveGenericComment() {
        this.props.saveGenericComment(this.props.selectedRuleInstance.ruleInstanceId, this.state.description, this.props.time.startDate, this.props.time.endDate);
    }
    _addCommentViaChartClick() {
        this.props.addCommentViaChartClick();
    }
    _addCommentViaGenericClick() {
        this.props.addCommentViaGenericClick();
    }
}

const bindAction = dispatch => {
    return {
        addCommentClick: () => dispatch(actions.addCommentClick()),
        addCommentClose: () => dispatch(actions.addCommentClose()),
        listCommentsClick: () => dispatch(actions.listCommentsClick()),
        listCommentsClose: () => dispatch(actions.listCommentsClose()),
        addCommentViaChartClick: () => dispatch(actions.addCommentViaChartClick()),
        addCommentViaChartClose: () => dispatch(actions.addCommentViaChartClose()),
        addCommentViaGenericClose: () => dispatch(actions.addCommentViaGenericClose()),
        addCommentViaGenericClick: () => dispatch(actions.addCommentViaGenericClick()),

        saveChartComment: (r, d, f, t) => dispatch(actions.saveChartComment(r, d, f, t)),
        saveGenericComment: (r, d, f, t) => dispatch(actions.saveGenericComment(r, d, f, t)),
        setDeletingComment: (comment) => dispatch(actions.setDeletingComment(comment)),
        deleteComment: (r, f, t) => dispatch(actions.deleteComment(r, f, t)),
        deleteConfirmClose: () => dispatch(actions.deleteConfirmClose()),

        navigate: (uri, data) => dispatch(router.push(uri, data)),
    };
};

const mapStateToProps = (state, ownProps) => ({
    isMenuOpen: state.menu.isOpen,
    addCommentOpen: state.chartcomment.addCommentOpen,
    listCommentsOpen: state.chartcomment.listCommentsOpen,
    addCommentViaChartOpen: state.chartcomment.addCommentViaChartOpen,
    addCommentViaGenericOpen: state.chartcomment.addCommentViaGenericOpen,
    selectedRuleInstance: state.ruleinstancesearch.selectedRuleInstance,
    chartCommentOpen: state.chartcomment.chartCommentOpen,
    genericCommentOpen: state.chartcomment.genericCommentOpen,
    deleteConfirmOpen: state.chartcomment.deleteConfirmOpen,

    commentList: state.chartcomment.commentList,
    
    time: state.time.timeRange,

    xVal: state.chartcomment.xVal,
    errors: state.chartcomment.errors,
});

export default connect(mapStateToProps, bindAction)(ChartCommentModals);


// WEBPACK FOOTER //
// ./src/components/ChartComment/ChartCommentModals.js